export class URLUtils {
  /**
   * Given a URL string removes the listed query parameters and returns the modified URL.
   * Works both with absolute and relative URL as it does not use the URL class,
   * but simply splits the URL string.
   *
   * @param url
   */
  static removeQueryParameters(url: string, paramsToRemove: string[]) {
    // Parse the URL
    const urlParts = url.split('?');
    if (urlParts.length < 2) {
      // If there are no query parameters, return the original URL
      return url;
    }

    const baseUrl = urlParts[0];
    const queryString = urlParts[1];

    // Split the query string into individual parameters
    const queryParams = queryString.split('&');

    // Create a new array to store filtered parameters
    const filteredParams = [];

    // Iterate through the parameters and keep only those not in paramsToRemove
    for (var i = 0; i < queryParams.length; i++) {
      var param = queryParams[i];
      var paramName = param.split('=')[0];
      if (paramsToRemove.indexOf(paramName) === -1) {
        filteredParams.push(param);
      }
    }

    // Reconstruct the URL with the filtered parameters
    return filteredParams.length > 0
      ? `${baseUrl}?${filteredParams.join('&')}`
      : baseUrl;
  }

  static addQueryParameter(
    url: string,
    paramName: string,
    paramValue: string
  ): string {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${paramName}=${encodeURIComponent(paramValue)}`;
  }
}
